module.exports = __webpack_public_path__ + "media/images/landing/fliist_logo_retina_ru-1c296fe3512aa8856c7a4401b1638413.png";